import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRouter } from '@/hooks/useRouter';
import { filterSlides } from '@/redux/modules/filterSlides';
import {
  getCampgroundGalleryHeader,
  getGalleryHeader,
} from '@/redux/selectors/listing/galleryHeader';
import { createListingUrlObj } from '@/utility/routes';

import GalleryCategories from './GalleryCategories';

interface IGalleryHeaderProps {
  isCampground?: boolean;
}

const GalleryCategoriesContainer = ({ isCampground }: IGalleryHeaderProps) => {
  const tabs = useSelector(isCampground ? getCampgroundGalleryHeader : getGalleryHeader);

  const router = useRouter();
  const dispatch = useDispatch();
  const active = Number(router.query.tab) || 0;
  const handleChangeFilter = (index: number) => {
    // @ts-expect-error fixable: unchecked index access
    const category = tabs.items[index].id;
    scrollToTop();
    category && dispatch(filterSlides(category));
    router.push(createListingUrlObj({ ...router.query, tab: index }), undefined, { shallow: true });
  };

  const scrollToTop = () => {
    typeof window === 'object' && window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const category = tabs.items[active]?.id;
    dispatch(filterSlides(category));
    // we only want to update category when it first loads
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GalleryCategories active={active} items={tabs.items} handleChangeFilter={handleChangeFilter} />
  );
};

export default GalleryCategoriesContainer;
